module.exports = __webpack_public_path__ + "assets/img/serve2.fbd0df38.png";